import React from "react";
import { Link } from "react-router-dom";

function Text() {
  return (
    <div>
      <h1>아쉽네요 다시 만들어 드릴게요</h1>
      <Link to="/">처음으로</Link>
    </div>
  );
}

export default Text;
